









import { Component, Vue } from "vue-property-decorator";
import { TreatmentApi } from "./treatmentApi";
import CzUndoBar from "../cz/CzUndoBar.vue";

// Marks a moment of "Today" and offers "Undo", which only removes what that mark added.
// A moment marked earlier, or one by one, is unmarked from "My treatment".
@Component({ components: { CzUndoBar } })
export default class TreatmentRecorder extends Vue {
  message: string = "";
  lastOperation: string = "";
  operations: { [slot: string]: string } = {};
  failed: (() => Promise<void>) | null = null;

  // The day travels with the mark: a screen left open past midnight marks the day it shows, never the next one.
  async toggle(row: any, day: string) {
    const done = row.items.length > 0 && row.items.every((i: any) => i.taken);
    const key = day + "|" + row.slot;
    if (!done) {
      const shown = row.items.map((i: any) => ({ treatmentId: i.treatmentId, version: i.version }));
      await this.run(row.slot, () => TreatmentApi.markSlot(row.slot, day, shown), () => this.toggle(row, day), (model: any) => {
        // A mark that added nothing (its first try did reach the server) has nothing to undo.
        const added = model.takes && model.takes.length > 0;
        if (added) this.operations[key] = model.operationId;
        this.lastOperation = added ? model.operationId : "";
        this.message = this.$t("Taken: {0}").toString().replace("{0}", row.label);
      });
      return;
    }
    const operation = this.operations[key];
    if (!operation && this.$listeners.locked) {
      this.$emit("locked");
      return;
    }
    if (!operation) {
      this.failed = null;
      this.lastOperation = "";
      this.message = this.$t("To unmark it, open My treatment").toString();
      return;
    }
    await this.undo(key, operation);
  }

  // Operations are kept per day and slot: an undo never reaches a take of another day.
  async undo(key: string, operation: string) {
    const slot = key.split("|")[1];
    await this.run(slot, () => TreatmentApi.undoOperation(operation), () => this.undo(key, operation), () => {
      delete this.operations[key];
      this.lastOperation = "";
      this.message = "";
    });
  }

  undoLast() {
    const key = Object.keys(this.operations).find((k) => this.operations[k] === this.lastOperation);
    return key ? this.undo(key, this.lastOperation) : Promise.resolve();
  }

  retry() {
    const again = this.failed;
    this.failed = null;
    return again ? again() : Promise.resolve();
  }

  async run(slot: string, call: () => Promise<any>, again: () => Promise<void>, done: (model: any) => void) {
    this.$emit("busy", slot);
    const res = await call().catch(() => null);
    this.$emit("busy", "");
    if (!res || res.ok === false) {
      // What is on screen may be out of date (the treatment changed): show the current one.
      // A refusal is not retried: the patient checks the reloaded treatment and marks it again.
      this.$emit("failed");
      this.failed = res ? null : again;
      this.lastOperation = "";
      this.message = res && res.errorMsg ? res.errorMsg : this.$t("It was not saved.").toString();
      return;
    }
    this.failed = null;
    done(res.model);
    this.$emit("changed");
  }
}
